import AoneService from "../axiosbase";

const BASE_URL = "masters/api/v1/volumetric-divisor";

export const getDivisors = async (params) => {
  try {
    return await AoneService.get(`${BASE_URL}${params}`);
  } catch (error) {
    return error;
  }
};

export const getDivisorById = async (id) => {
  try {
    return await AoneService.get(`${BASE_URL}/${id}`);
  } catch (error) {
    return error;
  }
};

export const postDivisor = async (data) => {
  try {
    return await AoneService.post(BASE_URL, data);
  } catch (error) {
    return error;
  }
};

export const editDivisor = async (id, data) => {
  try {
    return await AoneService.put(`${BASE_URL}/${id}`, data);
  } catch (error) {
    return error;
  }
};

export const deleteDivisor = async (id) => {
  try {
    return await AoneService.delete(`${BASE_URL}/${id}`);
  } catch (error) {
    return error;
  }
};

export const bulkDeleteDivisors = async (data) => {
  try {
    return await AoneService.post(`${BASE_URL}/delete`, data);
  } catch (error) {
    return error;
  }
};

export const divisorTemplate = async () => {
  try {
    return await AoneService.get(`${BASE_URL}/template/download`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const importDivisors = async (data) => {
  try {
    return await AoneService.post(`${BASE_URL}/import`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return error;
  }
};

export const resolveDivisor = async (params) => {
  try {
    return await AoneService.get(`${BASE_URL}/resolve${params}`);
  } catch (error) {
    return error;
  }
};

export const exportDivisors = async (params) => {
  try {
    return await AoneService.get(`${BASE_URL}/export${params}`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const editDivisorState = async (params, data) => {
  try {
    return await AoneService.patch(`${BASE_URL}/state/${params}`, data);
  } catch (error) {
    return error;
  }
};
